export type IoInputConfig = {
	type?: string;
	enable?: boolean;
	invert?: boolean;
};

export type IoControlConfig = {
	in_mode?: string;
	initial_state?: string;
	in_locked?: boolean;
};

export function buildIoFieldConfig<T extends Record<string, unknown>>(
	next: Partial<T>,
	cache: Partial<T>,
): Partial<T> {
	const config: Partial<T> = {};
	for (const key of Object.keys(next) as (keyof T)[]) {
		if (next[key] === undefined) continue;
		if (next[key] !== cache[key]) {
			config[key] = next[key];
		}
	}
	return config;
}

export function isNonEmptyConfig(config: object | undefined): boolean {
	return Boolean(config && Object.keys(config).length > 0);
}
